<template>
    <div>
        <div v-if="loading" class="is-clearfix has-background-white columns plisttable">
            <div class="column"></div>
            <p class="content has-text-centered is-size-6" style="padding-top:120px;">
                正在加载...
            </p>
            <div class="column"></div>
        </div>
        <div v-if="!loading && posts.length === 0" class="is-clearfix has-background-white columns plisttable">
            <div class="column"></div>
            <p class="content has-text-centered is-size-5 has-text-weight-semibold animated rubberBand" style="padding-top:120px;">
                当前还没有可以报名的岗位，感谢您的关注！
            </p>
            <div class="column"></div>
        </div>
        <template v-if="!loading && posts.length > 0">
            <div class="is-clearfix has-background-white columns is-vcentered plisttable" style="min-height: 0px;">
                <div class="column ">
                    <span class="is-size-5">
                        [{{ plan.bno }}]
                        <strong>{{ plan.name }}</strong>
                    </span>
                    <span class="is-size-6" style="margin-left: 10px; float: right;">
                        [共计
                        <span style="color: #00d1b2;;">{{ posts.length }}</span>
                        个岗位，报名截至：
                        <span style="color: #00d1b2;">{{ plan.rege }}]</span>
                    </span>
                </div>
            </div>
            <div class="is-clearfix has-background-white columns is-multiline plisttable">
                <div class=" column is-one-quarter is-info " panel-list-item-hover-color="danger" style="min-height: 400px; height: auto; " v-for="post in posts" :key="post.id">
                    <p class="panel-heading is-size-6" style="padding:0.75em 0.3em; background-color: #2196f3; color:white;">[{{ post.code }}] {{ post.name }}</p>
                    <div style="padding: 5px; " class="items">
                        <vue-custom-scrollbar class="scroll-area" :settings="settings">
                            <p>招聘人数：{{ post.count }}人，报名费{{ post.fee }}元</p>
                            <p>招聘单位：{{ post.unit }}</p>
                            <p v-if="post.dept">用人单位：{{ post.dept }}</p>
                            <p v-if="post.cate">岗位级别：{{ post.cate }}{{ post.level }}</p>
                            <p v-if="post.age">年龄要求：{{ post.age }}</p>
                            <p v-if="post.edu">学历要求：{{ post.edu }}</p>
                            <p v-if="post.major">专业要求：{{ post.major }}</p>
                            <p v-if="post.cert">证书要求：{{ post.cert }}</p>
                            <p v-if="post.memo">备注信息</p>
                            <p>{{ post.memo }}</p>
                        </vue-custom-scrollbar>
                    </div>
                    <div class="baoming">
                        <router-link :to="{ name: 'RecPlanNote', query: { id: post.id, pid: plan.id } }">
                            <button type="button" class="button is-small is-link is-outlined is-fullwidth is-info is-ripple">
                                立即报名
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<style>
.items {
    border-left: #2196f3 1px solid;
    border-right: #2196f3 1px solid;
    border-bottom: #2196f3 1px solid;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    min-height: 280px;
    height: 280px;
}

.items {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
}

.baoming {
    margin-top: 10px;
}
.scroll-area {
    position: relative;
    margin: auto;
    width: auto;
    height: 262px;
}
</style>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
export default {
    name: 'RecPostList',
    components: {
        vueCustomScrollbar
    },
    data() {
        return {
            loading: true,
            plan: {},
            posts: [],
            settings: {
                suppressScrollY: false,
                suppressScrollX: false,
                wheelPropagation: false
            }
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        // scrollHanle(evt) {
        //     // console.log(evt)
        // },
        init() {
            this.plan = JSON.parse(sessionStorage.getItem('Plan_' + this.$route.query.id) || '{}')

            this.doLoad()
        },
        doLoad() {
            this.loading = true
            if (!this.plan || !this.plan.id) {
                this.$http
                    .get('/comm/data/plan/simple', {
                        params: {
                            _: new Date().getTime() / 1000 / 60,
                            id: this.$route.query.id
                        }
                    })
                    .then(result => {
                        this.plan = result.data
                        sessionStorage.setItem('Plan_' + this.plan.id, JSON.stringify(this.plan))
                    })
            }
            this.$http
                .get('/comm/data/plan/posts', {
                    params: {
                        _: new Date().getTime() / 1000 / 60,
                        id: this.$route.query.id
                    }
                })
                .then(result => {
                    this.posts = result.datas || []
                    this.loading = false
                    if (this.posts) {
                        this.posts.forEach(post => {
                            sessionStorage.setItem('Post_' + post.id, JSON.stringify(post))
                        })
                    }
                })
        }
    }
}
</script>
